/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export let FilterPreset = /*#__PURE__*/function (FilterPreset) {
  FilterPreset["ALL_CLOSINGS"] = "ALL_CLOSINGS";
  FilterPreset["TODAY_CLOSINGS_WITH_OUTSTANDING_ESIGN_DOCS"] = "TODAY_CLOSINGS_WITH_OUTSTANDING_ESIGN_DOCS";
  FilterPreset["IMMEDIATE_CLOSINGS_WITH_DOCS"] = "IMMEDIATE_CLOSINGS_WITH_DOCS";
  FilterPreset["TODAY_AND_EARLIER_CLOSINGS_WITH_OPEN_TASKS"] = "TODAY_AND_EARLIER_CLOSINGS_WITH_OPEN_TASKS";
  return FilterPreset;
}({});